function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  viewBox: "0 0 64 64",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#292A2B",
  fillOpacity: 0.18,
  fillRule: "evenodd",
  d: "M32 0c17.673 0 32 14.327 32 32 0 9.334-3.997 17.735-10.372 23.585C49.75 47.546 41.523 42 32 42s-17.75 5.546-21.628 13.585C3.997 49.735 0 41.335 0 32 0 14.327 14.327 0 32 0m0 12c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-person-circle.svg";
export { SvgComponent as ReactComponent };